import { Dialog } from '@buffer-mono/popcorn'

import { Facebook } from '../../../..//exports/Orchestrator/channelConnections/components/services/Facebook/Facebook'
import type { OnRedirectParams } from '../../../../exports/Orchestrator/channelConnections/types'
import { useModalManager } from '../../../ModalManager/hooks/useModalManager'
import { redirectToUrl } from '../../../../common/utils/urls'

import styles from './FacebookSelectAccountType.module.css'

import type { JSX } from 'react'

export function FacebookSelectAccountTypeDialog(): JSX.Element {
  const onRedirect = (args: OnRedirectParams): void => {
    const { redirectUrl } = args
    redirectToUrl(redirectUrl)
  }

  const { modalData: data, dismissModal: closeAction } = useModalManager()

  return (
    <Dialog
      open
      onOpenChange={(): void => {
        // custom close action
        if (data?.onCustomCloseAction) {
          data.onCustomCloseAction()
        }

        // default close action to dismiss modal
        closeAction()
      }}
    >
      <Dialog.Content className={styles.content}>
        <Facebook onRedirect={onRedirect} />
      </Dialog.Content>
    </Dialog>
  )
}

export default FacebookSelectAccountTypeDialog
